import { Checkbox } from "@chakra-ui/react";
import React from "react";

export const CustomCheckbox = ({
                                   border = '5px',
                                   color = 'neutral.900',
                                    background,
                                    width,
                                    height,
                                   ...props
                               }) => {
    return (
        <Checkbox
            width={width}
            height={height}
            size="lg"
            color={color}
            borderRadius={border}
            sx={{
                // Style the internal control box <span>
                'span.chakra-checkbox__control': {
                    border: '1px solid',
                    borderColor: 'neutral.800',
                    borderRadius: '6px',
                    backgroundColor: 'neutral.900',
                    _checked: {
                        backgroundColor: background, // or any custom color
                        borderColor: background,
                    },
                },

            }}
            {...props}
        >
        </Checkbox>
    );
};
